<template>
  <div class="tableBox11">
      <div class="box11Title">巡检</div>
      <el-table
        :data="tableData"
        border
        style="width: 98%;margin: auto; height: 243px"
        :header-cell-style="{padding: '9px 3px'}"
        :cell-style="{padding: '8px 3px'}">
        <el-table-column
          prop="number"
          label="编号">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
        </el-table-column>
        <el-table-column
          prop="planStartTime"
          label="计划开始时间">
        </el-table-column>
        <el-table-column
          prop="emp"
          label="巡检人">
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="expireBox">
        <el-pagination
          small
          layout="prev, pager, next" @current-change="handleChange"
          :total="total" :current-page="curPage" :page-size="limit">
        </el-pagination>
      </div>
    </div>
</template>

<script>
import { getXjList } from "@/api/earlyWarning"
export default {
  name: "xj",
  data() {
    return {
      tableData: [],
      total: 0,
      curPage: 1,
      limit: 5
    }
  },
  methods: {
    getList() {
      getXjList({ limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    handleChange(val) {
      this.curPage = val
      this.getList()
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
  .tableBox11 {
    width: 49%;
    height: 300px;
    border: 1px solid rgb(232,232,232);
    margin-right: 1%;
    margin-bottom: 10px;
  }
  .box11Title {
    padding-left: 8px;
    font-weight: 600
  }
  .expireBox {
    text-align: right;
    margin-top: 3px
  }
</style>